export const LOGGED_IN_SIGNUP_STEPS_UK = [
  'business',
  'check-eligibility',
  'applicant',
  'offers',
  'check',
  'check-skipped',
  'documents',
  'decision',
] as const;

export const LOGGED_IN_SIGNUP_STEPS_DE = [
  'schritt-1',
  'schritt-2',
  'schritt-3',
  'angebote',
  'eignungscheck',
] as const;

const LOGGED_IN_SIGNUP_DIRECT_STEPS_UK = [
  'business',
  'company-questions', // New AI split test route
  'check-eligibility',
  'applicant',
  'offers',
  'check',
  'documents',
] as const;

export const SIGNUP_STEPS_DIRECT_UK = [
  '',
  'new',
  ...LOGGED_IN_SIGNUP_DIRECT_STEPS_UK,
] as const;

export const SIGNUP_STEPS_PARTNER_UK = [
  '',
  'new',
  ...LOGGED_IN_SIGNUP_STEPS_UK,
] as const;

export const SIGNUP_STEPS_DE = [
  '',
  'neu',
  ...LOGGED_IN_SIGNUP_STEPS_DE,
] as const;

export const UK_DIRECT_BASE_PATHNAME = 'apply';
export const DE_DIRECT_BASE_PATHNAME = 'kreditwunsch';
export const UK_DIRECT_BASE_OB_LINK_PATHNAME = 'link-open-banking';
export const UK_PREVIEW_LINK_BANK_PATHNAME = 'preview-link-bank';

export const IWOCA_AFFILIATE_TAG = 'iwoca';

export const DIRECTOR_DATA_REQUIREMENT_ERRORS = [
  'check_directors_match_companies_house',
  'check_director_as_applicant',
  'check_director_as_guarantor',
];

export const CREDIT_DATA_REQUIREMENT_ERRORS = [
  'complete_personal_credit_check',
  'complete_additional_personal_credit_check',
];

export const SELF_SERVE_DATA_REQUIREMENT_ERRORS = [
  // Director errors, I think all 3 errors will normally happen together
  ...DIRECTOR_DATA_REQUIREMENT_ERRORS,
  // Missmatching info, normally address isn't a match
  // Errors from the director will often cause this too
  ...CREDIT_DATA_REQUIREMENT_ERRORS,
];

export const ISOLATED_SPLIT_TESTS = {
  PARTNER_DECISION_PAGE_EXCLUSION_TEST: 'partner_decision_page_exclusion_test',
  REMOVE_VAT_REQUIREMENT_TEST: 'remove_vat_requirement_test',
  SIGNUP_NO_PG_TEST: 'signup_no_pg_test',
  DE_OPEN_BANKING_COPY_TEST: 'de_open_banking_copy_test_2025_q3',
  DE_ELIGIBILITY_PAGE_TEST: 'de_eligibility_page_test_2025_q3',
} as const;

export const EMPTY_ADDRESS = {
  houseNumber: '',
  houseName: '',
  streetLine1: '',
  streetLine2: '',
  town: '',
  postcode: '',
  equifaxToken: '',
};
